import { Badge, Box, Modal, Table, Text, Title } from "@mantine/core";
import { formatDateTransfer } from "../../common/FormatDate/FormatDate";

interface ApprovalHistoryData {
  fullName: string;
  mail: string;
  id: string;
  typeHistory: number;
  createBy: string;
  createDate: string;
  orderId: number;
  priceBeforeChange: number;
  priceAfterChange: number;
  typeAction: number;
  attr1: string | null;
  attr2: string | null;
  attr3: string | null;
}

interface ApprovalHistoryModalProps {
  opened: boolean;
  onClose: () => void;
  data: ApprovalHistoryData[];
  orderNumber: string;
}

const ApprovalHistoryModal = ({
  opened,
  onClose,
  data,
  orderNumber,
}: ApprovalHistoryModalProps) => {
  const getTypeActionText = (typeAction: number) => {
    switch (typeAction) {
      case 1:
        return "Giảm giá";
      case 2:
        return "Tăng giá";
      default:
        return "Không xác định";
    }
  };

  const getTypeActionColor = (typeAction: number) => {
    switch (typeAction) {
      case 1:
        return "red";
      case 2:
        return "green";
      default:
        return "gray";
    }
  };

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND",
    }).format(price);
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Title order={4}>Lịch sử duyệt giảm giá - Đơn hàng {orderNumber}</Title>
      }
      size="xl"
      centered
    >
      <Box>
        {data && data.length > 0 ? (
          <Table striped highlightOnHover>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>STT</Table.Th>
                <Table.Th>Người thực hiện</Table.Th>
                <Table.Th>Email</Table.Th>
                <Table.Th>Ngày thực hiện</Table.Th>
                <Table.Th>Giá trước thay đổi</Table.Th>
                <Table.Th>Giá sau thay đổi</Table.Th>
                {/* <Table.Th>Loại thao tác</Table.Th> */}
                <Table.Th>Ghi chú</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {data.map((item, index) => (
                <Table.Tr key={item.id}>
                  <Table.Td>{index + 1}</Table.Td>
                  <Table.Td>
                    <Text fw={500}>{item.fullName}</Text>
                  </Table.Td>
                  <Table.Td>
                    <Text size="sm" c="dimmed">
                      {item.mail}
                    </Text>
                  </Table.Td>
                  <Table.Td>{formatDateTransfer(item.createDate)}</Table.Td>
                  <Table.Td>
                    <Text fw={500}>{formatPrice(item.priceBeforeChange)}</Text>
                  </Table.Td>
                  <Table.Td>
                    <Text fw={500}>{formatPrice(item.priceAfterChange)}</Text>
                  </Table.Td>
                  {/* <Table.Td>
                    <Badge
                      color={getTypeActionColor(item.typeAction)}
                      size="sm"
                    >
                      {getTypeActionText(item.typeAction)}
                    </Badge>
                  </Table.Td> */}
                  <Table.Td>
                    <Text size="sm">{item.attr1 || ""}</Text>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        ) : (
          <Text ta="center" c="dimmed" py={20}>
            Không có dữ liệu lịch sử duyệt giảm giá
          </Text>
        )}
      </Box>
    </Modal>
  );
};

export default ApprovalHistoryModal;
